import { Checkbox, Stack, Text, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";

type Props = {
  form: any;
  setNoDenuncioAcosoLaboral: (value: boolean) => void;
};

const Component = ({ form, setNoDenuncioAcosoLaboral }: Props) => {
  const { t } = useTranslation();

  // Actions state
  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const [noneSelected, setNoneSelected] = useState(false);

  const actions = [
    "Se lo conté a un compañero/a.",
    "Hablé con mi jefe/a directo/a.",
    "Pedí que me cambien de lugar de trabajo con alguna otra excusa.",
    "Confronté a la persona.",
    "No comenté lo sucedido con nadie de mi organización.",
    "Hablé con recursos humanos pero decidí no seguir el proceso de investigación.",
    "Lo denuncié y seguí el proceso de investigación.",
    "Comencé a ausentarme para evitar la situación.",
    "No vi necesario hacer algo.",
  ];

  const actionOptions = actions.map(
    (_, index) => `AA_${String(index + 1).padStart(3, "0")}AL`
  );

  const noneOption = "AA_NONE";

  // Update form values
  useEffect(() => {
    if (noneSelected) {
      // When "Ninguna de las anteriores" is selected, set N.A values
      form.setFieldValue("AA_001_009AL", ["N.A"]);
    } else {
      // Normal behavior when specific actions are selected
      form.setFieldValue("AA_001_009AL", selectedValues);
      setNoDenuncioAcosoLaboral(!selectedValues.includes("AA_007AL"));
    }
  }, [selectedValues, noneSelected]);

  const handleCheckboxChange = (value: string) => {
    if (value === noneOption) {
      if (noneSelected) {
        setNoneSelected(false);
        setSelectedValues([]);
      } else {
        setNoneSelected(true);
        setSelectedValues([noneOption]);
      }
    } else {
      setNoneSelected(false);
      if (selectedValues.includes(value)) {
        setSelectedValues((prev) =>
          prev.filter((v) => v !== value && v !== noneOption)
        );
      } else {
        setSelectedValues((prev) => [
          ...prev.filter((v) => v !== noneOption),
          value,
        ]);
      }
    }
  };

  return (
    <Stack spacing="sm">
      <Text fw={500} size="sm" color="gray.8">
        ¿Qué acciones tomaste frente a la situación de acoso que experimentaste?
      </Text>
      <Text fz="xs" color="red">
        Puedes marcar más de una opción en esta pregunta.
      </Text>

      <Stack spacing={4}>
        {actions.map((action, index) => (
          <Checkbox
            key={actionOptions[index]}
            label={action}
            checked={selectedValues.includes(actionOptions[index])}
            disabled={noneSelected}
            onChange={() => handleCheckboxChange(actionOptions[index])}
            size="sm"
            styles={{
              body: { alignItems: "center" },
              label: {
                lineHeight: 1.2,
                minHeight: "2rem",
                display: "flex",
                alignItems: "center",
              },
            }}
          />
        ))}
        <Checkbox
          label="Ninguna de las anteriores"
          checked={noneSelected}
          onChange={() => handleCheckboxChange(noneOption)}
          size="sm"
          color="gray"
          styles={{
            body: { alignItems: "center" },
            label: {
              lineHeight: 1.2,
              minHeight: "2rem",
              display: "flex",
              alignItems: "center",
            },
          }}
        />
      </Stack>
    </Stack>
  );
};

export default Component;
